import React from 'react'
import { Route } from 'react-router-dom'
import Reports from './collections/reports'
import TransactionReport from './components/transactionReport'

export default [
  <Route exact path='/reports' component={Reports} />,
  <Route exact path='/transactionReport' component={TransactionReport} />
]



// WEBPACK FOOTER //
// ./src/customRoutes.js